<template>
    <div id="app" class="flex flex-col" :class="[$route.name]">
        <!-- pc顶部导航 -->
        <web-header></web-header>

        <!-- 视图 -->
        <router-view />

        <!-- 回到顶部 -->
        <!-- <back-to-top /> -->
    </div>
</template>

<script>
import WebHeader from '@/components/common/Header';
import BackToTop from '@/components/base/BackToTop';

export default {
    components: {
        WebHeader,
        BackToTop,
    },

    data() {
        return {};
    },

    computed: {},

    watch: {},

    created() {},

    methods: {},
};
</script>

<style lang="scss">
#app {
    transition: transform 0.2s ease-in-out;
    height: 100vh;
    width: 1600px;
    padding: 130px 0 0;
    margin: 0 auto;
    box-sizing: border-box;
    text-align: center;

    @include media-mob {
        // width: 335px;
        width: 100%;
        padding-top: 120px;

        &.detail {
            padding-top: 74px;
        }
    }
}
</style>
